var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"overflow-x-auto; overflow-y-auto",style:(_vm.mainContainerSize)},[_c('ViewpointCreator',{attrs:{"appEmbed":_vm.appEmbed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }